import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

@Component
/**
 * Counter Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Title of countdown
     */
    @Prop({ type: String }) title!: string | Array<string>;

    /**
     * Default Timezone
     */
    @Prop({ type: String, default: 'Asia/Tehran' }) timezone!: string;

    /**
     * Targe Time (milisecond)
     */
    @Prop({ type: [String, Number] }) targetTime!: string|number;

    /**
     * Put the labels at bottom of counter
     */
    @Prop({ type: Boolean }) labelReverse!: boolean;

    /**
     * Counter number color
     */
    @Prop({ type: String, default: 'body' }) color!: string;
}
